import { Routes, Route } from 'react-router-dom'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import SeoMetadata from '../../components/Seo/SeoMetadata'
// import HomePage from '../../pages/Home/HomePage'
import ImplementationPage from '../../pages/Implementation/ImplementationPage'
import LeadershipNewPage from '../../pages/LeadershipNew/LeadershipNewPage'
import NotFound from '../../pages/NotFound'

const AppRouter = () => (
  <div className="site-shell">
    <SeoMetadata />
    <Header />
    <main className="main-content">
      <Routes>
        <Route path="/implementation" element={<ImplementationPage />} />
        <Route path="/" element={<LeadershipNewPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    <Footer />
  </div>
)

export default AppRouter
